import { Scanner } from "@yudiel/react-qr-scanner/dist/cjs";
import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import Api from "../../../../../Services/Api";
import {
  fetchDataAsync,
  FormatCurrencyWithoutSymbol,
} from "../../../../../Services/Utils";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleRadio from "../../../../../modules/SimpleRadio";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import { ACTIVITY_TYPE, HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import {
  getTableColumns,
  getTableColumnsWithoutQR,
  getTableColumnsWithQR,
} from "../../config/tableConfig";
import {
  INITIAL_DATA_TABLE_JASA_JOB,
  INITIAL_DATA_TABLE_PART_NON_QR,
  INITIAL_DATA_TABLE_PART_QR,
  TIPE_PEMBAYARAN_NON_TUNAI_OPTIONS,
} from "../../constant";
import {
  calculateAndSetPromo,
  constructDataFromPackage,
  countAfterDiscount,
  countBeforeDiscount,
  countDiscount,
  countEstimateTime,
} from "../../utils";
import { Line } from "../ui/line";
import SummaryRow from "../ui/summaryRow";

class TabDataTransaksiFJB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      scannerVisible: false,
      locatorOptions: [],
      packageOptions: [],
      bankOptions: [],
      jasaOptions: [],
      partNonQrOptions: [],
      partQrOptions: [],
      promoOptions: [],
      backupTable: {
        // untuk backup, case: kalo user nge nullin diskon terus save, apply backupnya
        tableQr: null,
        tableNonQr: null,
        tableJasa: null,
      },
      //need to do something about this deselect promo
      backupPromo: {
        tableQr: null,
        tableNonQr: null,
        tableJasa: null,
      },
    };
  }

  componentDidMount() {
    this.loadDDL();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCabang = prevProps?.formData?.kodeCabang?.value;
    const currCabang = this.props.formData?.kodeCabang?.value;
    if (currCabang && currCabang !== prevCabang) {
      this.loadDDL();
      this.setState((prev) => ({
        ...prev,
        partNonQrOptions: [],
        partQrOptions: [],
        promoOptions: [],
        backupTable: {
          tableQr: null,
          tableNonQr: null,
          tableJasa: null,
        },
      }));
    }
  }

  loadDDL = async () => {
    const { onTriggerLoading, setError, formData, isDirectSales } = this.props;
    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getLocatorDataTransactionFjb,
        menuName: "Faktur Jual Bengkel",
        setError: setError,
        args: [formData.kodeCabang?.value],
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getDataPackageFjb,
        menuName: "Faktur Jual Bengkel",
        setError: setError,
        args: {
          kodeVariant: isDirectSales
            ? "ALL"
            : formData.dataUnit?.kodeVarian?.value,
          kodeCabang: formData.kodeCabang?.value,
          serviceDate: moment().format("YYYY-MM-DD"),
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getJasaFjb,
        menuName: "Faktur Jual Bengkel",
        setError: setError,
        args: {
          kodeCabang: formData?.kodeCabang?.value,
          kodeVariant: isDirectSales
            ? "ALL"
            : formData?.dataUnit?.kodeVarian?.value,
          serviceDate: moment().format("DD-MM-YYYY"),
          serviceCode: "%",
          serviceName: "%",
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterBank,
        setError: this.props.setError,
        menuName: "Faktur Jual Bengkel",
        args: {
          paramFilters: {
            kodecabang: formData?.kodeCabang?.value
              ? [formData?.kodeCabang?.value]
              : [],
          },
        },
      }),
    ];

    if (formData?.dataTransaksi?.locator?.value) {
      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPartFJB,
          menuName: "Faktur Jual Bengkel",
          setError: setError,
          args: {
            kodeCabang: formData?.kodeCabang?.value,
            kodeVariant: formData?.dataUnit?.kodeVarian?.value,
            serviceDate: moment().format("DD-MM-YYYY"),
            kodePart: "%",
            partName: "%",
            qrCode: true,
            kodeLokator: formData?.dataTransaksi?.locator?.value,
          },
        })
      );
      promises.push(
        fetchDataAsync({
          asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPartFJB,
          menuName: "Faktur Jual Bengkel",
          setError: setError,
          args: {
            kodeCabang: formData?.kodeCabang?.value,
            kodeVariant: formData?.dataUnit?.kodeVarian?.value,
            serviceDate: moment().format("DD-MM-YYYY"),
            kodePart: "%",
            partName: "%",
            qrCode: false,
            kodeLokator: formData?.dataTransaksi?.locator?.value,
          },
        })
      );
    }

    onTriggerLoading();
    const result = await Promise.all(promises);
    onTriggerLoading();
    result.forEach((res, index) => {
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        if (index === 0) {
          this.setState({
            locatorOptions: res.data.data.map((item) =>
              mapToObjectDDL(item.nameLocation, item.kodeLocation)
            ),
          });
        }
        if (index === 1) {
          this.setState({
            packageOptions: res?.data?.data?.data.map((item, index) => ({
              index: index,
              label: item.packageName,
              value: item.packageId,
              ...item,
            })),
          });
        }
        if (index === 2) {
          this.setState({
            jasaOptions: res?.data?.data,
          });
        }
        if (index === 3) {
          this.setState({
            bankOptions: res.data.data.map((item) =>
              mapToObjectDDL(
                `${item.bankName} - ${item.accountNumber}`,
                item.bankCode
              )
            ),
          });
        }
        if (index === 4) {
          this.setState({
            partQrOptions: res?.data?.data,
          });
        }
        if (index === 5) {
          this.setState({
            partNonQrOptions: res?.data?.data,
          });
        }
      }
    });
  };

  loadPart = async (locator) => {
    const { onTriggerLoading, setError, formData } = this.props;
    if (!locator) {
      return;
    }

    const promises = [
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPartFJB,
        menuName: "Faktur Jual Bengkel",
        setError: setError,
        args: {
          kodeCabang: formData?.kodeCabang?.value,
          kodeVariant: formData?.dataUnit?.kodeVarian?.value,
          serviceDate: moment().format("DD-MM-YYYY"),
          kodePart: "%",
          partName: "%",
          qrCode: true,
          kodeLokator: locator,
        },
      }),
      fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPartFJB,
        menuName: "Faktur Jual Bengkel",
        setError: setError,
        args: {
          kodeCabang: formData?.kodeCabang?.value,
          kodeVariant: formData?.dataUnit?.kodeVarian?.value,
          serviceDate: moment().format("DD-MM-YYYY"),
          kodePart: "%",
          partName: "%",
          qrCode: false,
          kodeLokator: locator,
        },
      }),
    ];

    onTriggerLoading();
    const result = await Promise.all(promises);
    onTriggerLoading();
    result.forEach((res, index) => {
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        if (index === 0) {
          this.setState({
            partQrOptions: res?.data?.data,
          });
        }
        if (index === 1) {
          this.setState({
            partNonQrOptions: res?.data?.data,
          });
        }
      }
    });
  };

  handleSaveJob = (index) => {
    const { onSetState, formData, onTriggerAlert, pelanggaranJasa } = this.props;
    const table = formData.dataTransaksi?.dataJob;
    const data = table[index];

    if (pelanggaranJasa?.pelanggaranHarga?.includes(index)) {
      onTriggerAlert(
        "Informasi",
        "Terdapat perbedaan antara harga sistem dan harga diberikan, FJB butuh approval!"
      );
    }
    if (pelanggaranJasa?.pelanggaranDiskonPercent?.includes(index)) {
      onTriggerAlert(
        "Informasi",
        "FJB menggunakan diskon override, FJB butuh approval!"
      );
    }
    if (pelanggaranJasa?.pelanggaranDiskon?.includes(index)) {
      onTriggerAlert(
        "Informasi",
        "FJB menggunakan diskon override, FJB butuh approval!"
      );
    }

    //validate diskon & harga
    onSetState((prev) => {
      const data = [...prev.data.dataTransaksi.dataJob];
      data[index] = {
        ...data[index],
        prevHargaDiberikan: data[index].hargaDiberikan,
        prevDiskonDiberikanCurrency: data[index].diskonDiberikanCurrency,
        prevDiskonDiberikan: data[index].diskonDiberikan,
        isSaved: true,
      };

      return {
        ...prev,
        data: {
          ...prev.data,
          dataTransaksi: {
            ...prev.data.dataTransaksi,
            dataJob: data,
            totalJasaSebelumDiskon: countBeforeDiscount(data),
            totalJasaDiskon: countDiscount(data),
            totalJasaSesudahDiskon: countAfterDiscount(data),
            totalEstimasiWaktu: countEstimateTime(data),
          },
        },
      };
    });
  };

  handleAddBackup = (tableName, name, value) => {
    this.setState((prev) => ({
      ...prev,
      backupTable: {
        ...prev.backupTable,
        [tableName]: {
          ...prev.backupTable[tableName],
          [name]: value,
        },
      },
    }));
  };

  handleLocalPelanggaran = (tableName, type, index, isViolating) => {
    const map = {
      partQr: "pelanggaranPartQr",
      partNonQr: "pelanggaranPartNonQR",
      pelanggaranJasa: "pelanggaranJasa",
    };

    const stateKey = map[tableName];
    if (!stateKey) return;
    if (!isViolating) {
      if (
        this.state?.[stateKey]?.[type]?.find((item) => item === index) ===
        undefined
      ) {
        return;
      }
    }

    this.props.onSetState((prev) => {
      const prevData = prev?.[stateKey]?.[type] || [];

      const set = new Set(prevData);

      if (set.has(index) && !isViolating) {
        set.delete(index);
      } else {
        set.add(index);
      }

      return {
        ...prev,
        [stateKey]: {
          ...prev[stateKey],
          [type]: Array.from(set), // simpan kembali sebagai array
        },
      };
    });
  };

  getTableConfig = () => {
    const { jasaOptions } = this.state;
    const { formData, isSO } = this.props;
    return getTableColumns({
      onChangeData: (index, name, value) =>
        this.setTableData("dataJob", index, name, value),
      jasaOptions: jasaOptions,
      dataTable: formData?.dataTransaksi.dataJob,
      onDelete: (index) => this.handleDeleteTableData("dataJob", index),
      onSave: this.handleSaveJob,
      onAddBackUp: this.handleAddBackup,
      onHandlePelanggaran: this.props.handlePelanggaran,
      isSo: isSO,
      onHandleLocalPelanggaran: this.handleLocalPelanggaran,
    });
  };

  handleSavePart = (index, tableName) => {
    const { formData, onTriggerAlert, pelanggaranPartNonQR, pelanggaranPartQr } = this.props;
    const table = formData.dataTransaksi[tableName];
    const data = table[index];
    if (tableName === "dataPartNonQR") {
      if (Number(data.qtyPart) > Number(data.qtyStock)) {
        return onTriggerAlert(
          "Informasi",
          "QTY diberikan tidak boleh lebih dari stock yang tersedia. Mohon periksa kembali."
        );
      }
      if (data.qtyStock === 0) {
        return onTriggerAlert(
          "Informasi",
          "QTY Stock 0, part tidak dapat digunakan. Silahkan Cek Kembali!"
        );
      }
      if (data.qtyPart === 0) {
        return onTriggerAlert(
          "Informasi",
          "QTY yang diberikan, tidak boleh kurang dari 1. Mohon periksa kembali"
        );
      }
      if (
        table.find(
          (item) =>
            item.kodePart?.value === data.kodePart?.value && item.isSaved
        )
      ) {
        return onTriggerAlert("Informasi", "Part sudah ada dalam list");
      }
      if (pelanggaranPartNonQR?.pelanggaranHarga?.includes(index)) {
        onTriggerAlert(
          "Informasi",
          "Terdapat perbedaan antara harga sistem dan harga diberikan, FJB butuh approval!"
        );
      }
      if (pelanggaranPartNonQR?.pelanggaranDiskonPercent?.includes(index)) {
        onTriggerAlert(
          "Informasi",
          "FJB menggunakan diskon override, FJB butuh approval!"
        );
      }
      if (pelanggaranPartNonQR?.pelanggaranDiskon?.includes(index)) {
        onTriggerAlert(
          "Informasi",
          "FJB menggunakan diskon override, FJB butuh approval!"
        );
      }
    } else {
      if (!data.qrCode) {
        return onTriggerAlert(
          "Informasi",
          "Terdapat Data QR Yang Belum Diisi. Harap Periksa Kembali"
        );
      }
      if (pelanggaranPartQr?.pelanggaranHarga?.includes(index)) {
        onTriggerAlert(
          "Informasi",
          "Terdapat perbedaan antara harga sistem dan harga diberikan, FJB butuh approval!"
        );
      }
      if (pelanggaranPartQr?.pelanggaranDiskonPercent?.includes(index)) {
        onTriggerAlert(
          "Informasi",
          "FJB menggunakan diskon override, FJB butuh approval!"
        );
      }
      if (pelanggaranPartQr?.pelanggaranDiskon?.includes(index)) {
        onTriggerAlert(
          "Informasi",
          "FJB menggunakan diskon override, FJB butuh approval!"
        );
      }
    }

    this.handleDeletePelanggaran(tableName, index);
    const { onSetState } = this.props;
    onSetState((prev) => {
      const data = [...prev.data.dataTransaksi[tableName]];
      data[index] = {
        ...data[index],
        prevHargaDiberikan: data[index].hargaDiberikan,
        prevDiskonDiberikanCurrency: data[index].diskonDiberikanCurrency,
        prevDiskonDiberikan: data[index].diskonDiberikan,
        totalHarga:
          Number(data[index].qtyPart) * Number(data[index].hargaDiberikan) -
          Number(data[index].diskonDiberikanCurrency),
        isSaved: true,
      };

      const otherData =
        tableName === "dataPartQR" ? "dataPartNonQR" : "dataPartQR";

      const combinedData = [
        ...data,
        ...(prev.data.dataTransaksi?.[otherData] || []),
      ];

      return {
        ...prev,
        data: {
          ...prev.data,
          dataTransaksi: {
            ...prev.data.dataTransaksi,
            [tableName]: data,
            totalPartSebelumDiskon: countBeforeDiscount(combinedData, "part"),
            totalPartDiskon: countDiscount(combinedData),
            totalPartSesudahDiskon: countAfterDiscount(combinedData),
            //belum ada menu hotline
            // totalTitipanHotlin: data.reduce(
            //   (prev, curr) =>
            //     prev + Number(curr?.totalHarga),
            //   0
            // ),
            // totalKelebihanKekurangan: data.reduce(
            //   (prev, curr) =>
            //     prev + Number(curr?.estimasiWaktu),
            //   0
            // ),
          },
        },
      };
    });
  };

  getTableConfigWithQR = () => {
    const { formData, isSO } = this.props;
    const { partQrOptions } = this.state;
    return getTableColumnsWithQR({
      partQrOptions: partQrOptions || [],
      onChangeData: (index, name, value) =>
        this.setTableData("dataPartQR", index, name, value),
      dataTable: formData?.dataTransaksi.dataPartQR,
      onDelete: (index) => this.handleDeleteTableData("dataPartQR", index),
      onSave: (index) => this.handleSavePart(index, "dataPartQR"),
      onAddBackUp: () => this.handleAddBackup,
      onHandlePelanggaran: this.props.handlePelanggaran,
      isSo: isSO,
      onHandleLocalPelanggaran: this.handleLocalPelanggaran,
    });
  };

  getTableConfigWithoutQR = () => {
    const { formData, isSO } = this.props;
    const { partNonQrOptions } = this.state;

    return getTableColumnsWithoutQR({
      partOptions: partNonQrOptions,
      onChangeData: (index, name, value) =>
        this.setTableData("dataPartNonQR", index, name, value),
      dataTable: formData?.dataTransaksi.dataPartNonQR,
      onDelete: (index) => this.handleDeleteTableData("dataPartNonQR", index),
      onSave: (index) => this.handleSavePart(index, "dataPartNonQR"),
      onAddBackUp: this.handleAddBackup,
      onHandlePelanggaran: this.props.handlePelanggaran,
      isSo: isSO,
      onHandleLocalPelanggaran: this.handleLocalPelanggaran,
    });
  };

  handleScannerVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      scannerVisible: !prevValue.scannerVisible,
    }));
  };

  setValue = (name, value) => {
    const { onSetSpesificData } = this.props;
    onSetSpesificData("dataTransaksi", name, value);
  };

  setTableData = (tableName, index, name, value) => {
    const { onSetState } = this.props;
    onSetState((prev) => {
      const data = [...prev.data.dataTransaksi[tableName]];
      data[index] = {
        ...data[index],
        [name]: value,
      };

      return {
        ...prev,
        data: {
          ...prev.data,
          dataTransaksi: {
            ...prev.data.dataTransaksi,
            [tableName]: data,
          },
        },
      };
    });
  };

  handleAddTableData = (tableName) => {
    const { onSetState } = this.props;
    let initialData = [];
    switch (tableName) {
      case "dataJob":
        initialData = INITIAL_DATA_TABLE_JASA_JOB;
        break;
      case "dataPartQR":
        initialData = INITIAL_DATA_TABLE_PART_QR;
        break;
      case "dataPartNonQR":
        initialData = INITIAL_DATA_TABLE_PART_NON_QR;
        break;

      default:
        initialData = [];
        break;
    }
    onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        dataTransaksi: {
          ...prev.data.dataTransaksi,
          [tableName]: [
            ...(prev.data.dataTransaksi[tableName] || []),
            initialData,
          ],
        },
      },
    }));
  };

  handleDeletePelanggaran = (tableName, index) => {
    const map = {
      dataPartQR: "pelanggaranPartQr",
      dataPartNonQR: "pelanggaranPartNonQR",
      dataJob: "pelanggaranJasa",
    };

    const stateKey = map[tableName];
    if (!stateKey) return;

    this.props.onSetState((prev) => {
      const prevData = prev[stateKey] || {};

      return {
        ...prev,
        [stateKey]: {
          pelanggaranDiskonPercent:
            prevData?.pelanggaranDiskonPercent?.filter(
              (item) => item !== index
            ) || null,
          pelanggaranDiskon:
            prevData?.pelanggaranDiskon?.filter((item) => item !== index) ||
            null,
          pelanggaranHarga:
            prevData?.pelanggaranHarga?.filter((item) => item !== index) ||
            null,
        },
      };
    });
  };

  handleDeleteTableData = async (tableName, index) => {
    const { backupTable } = this.state;
    const { onSetState, formData } = this.props;
    const keyTableBackup =
      tableName === "dataJob"
        ? "tableJasa"
        : tableName === "dataPartQR"
        ? "tableQr"
        : "tableNonQr";

    const dataBackup = backupTable[keyTableBackup]?.[index];

    this.handleDeletePelanggaran(tableName, index);

    if (dataBackup && !formData.dataTransaksi[tableName][index].isSaved) {
      this.setState((prev) => {
        const prevBackup = prev.backupTable;
        delete prevBackup[keyTableBackup][index];
        return {
          ...prev,
          backupTable: prevBackup,
        };
      });
      onSetState((prev) => {
        const newData = [...prev.data.dataTransaksi[tableName]];
        newData[index] = {
          ...dataBackup,
          isSaved: true,
        };

        return {
          ...prev,
          data: {
            ...prev.data,
            dataTransaksi: {
              ...prev.data.dataTransaksi,
              [tableName]: newData,
            },
          },
        };
      });
      return;
    }

    //need to change this next time
    await onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        dataTransaksi: {
          ...prev.data.dataTransaksi,
          [tableName]: prev.data.dataTransaksi[tableName]?.filter(
            (_, idx) => index !== idx
          ),
        },
      },
    }));
    this.handleRecalculateTotal()
  };

  handleRecalculateTotal = () => {
    const { onSetState } = this.props;
    onSetState((prev) => {
      const prevQr = [...(prev.data.dataTransaksi?.dataPartQR || [])];
      const prevNonQr = [...(prev.data.dataTransaksi?.dataPartNonQR || [])];
      const prevJob = [...(prev.data.dataTransaksi?.dataJob || [])];

      const merged = [...prevQr, ...prevNonQr];

      return {
        ...prev,
        data: {
          ...prev.data,
          dataTransaksi: {
            ...prev.data.dataTransaksi,
            totalPartSebelumDiskon: countBeforeDiscount(merged, "part"),
            totalPartDiskon: countDiscount(merged),
            totalPartSesudahDiskon: countAfterDiscount(merged),
            totalJasaSebelumDiskon: countBeforeDiscount(prevJob),
            totalJasaDiskon: countDiscount(prevJob),
            totalJasaSesudahDiskon: countAfterDiscount(prevJob),
          },
        },
      };
    });
  };

  handleResetPackage = async (isRecalculateTotal) => {
    const { onSetState } = this.props;
    await  onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        dataTransaksi: {
          ...prev.data.dataTransaksi,
          dataPartQR: prev.data.dataTransaksi?.dataPartQR?.filter(
            (item) => !item.dariPackage
          ),
          dataPartNonQR: prev.data.dataTransaksi?.dataPartNonQR?.filter(
            (item) => !item.dariPackage
          ),
          dataJob: prev.data.dataTransaksi?.dataJob?.filter(
            (item) => !item.dariPackage
          ),
        },
      },
    }));
  };

  getDetailPackage = async (val) => {
    await this.handleResetPackage();
    if(!val?.value){
      this.handleRecalculateTotal()
      return;
    }
    const { onTriggerLoading, setError, formData, onSetState, isDirectSales } =
      this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPartAndJasaByPackageId,
      menuName: "Faktur Jual Bengkel",
      setError,
      args: {
        packageId: val?.packageId,
        kodeVariant: isDirectSales
          ? "ALL"
          : formData?.dataUnit?.kodeVarian?.value,
        kodeCabang: formData?.kodeCabang?.value,
        kodeLokator: formData?.dataTransaksi?.locator?.value,
        serviceDate: moment().format("YYYY-MM-DD"),
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const { resultQR, resultPart, resultService } = constructDataFromPackage(
        res.data.data
      );

      onSetState((prev) => {
        const prevQr =
          [...(prev.data.dataTransaksi?.dataPartQR || [])]?.filter(
            (item) => !item.dariPackage
          ) || [];
        const prevNonQr =
          [...(prev.data.dataTransaksi?.dataPartNonQR || [])]?.filter(
            (item) => !item.dariPackage
          ) || [];
        const prevJob =
          [...(prev.data.dataTransaksi?.dataJob || [])]?.filter(
            (item) => !item.dariPackage
          ) || [];

        const mergedQr = [...resultQR, ...prevQr];
        const mergedNonQr = [...resultPart, ...prevNonQr];
        const merged = [...mergedQr, ...mergedNonQr];

        return {
          ...prev,
          data: {
            ...prev.data,
            dataTransaksi: {
              ...prev.data.dataTransaksi,
              dataPartQR:
                resultQR.length > 0
                  ? mergedQr
                  : prev.data.dataTransaksi?.dataPartQR,
              dataPartNonQR:
                resultPart.length > 0
                  ? mergedNonQr
                  : prev.data.dataTransaksi?.dataPartNonQR,
              dataJob:
                resultService.length > 0
                  ? [...resultService, ...prevJob]
                  : prev.data.dataTransaksi?.dataJob,
              totalPartSebelumDiskon: countBeforeDiscount(merged, "part"),
              totalPartDiskon: countDiscount(merged),
              totalPartSesudahDiskon: countAfterDiscount(merged),
              totalJasaSebelumDiskon: countBeforeDiscount([
                ...resultService,
                ...prevJob,
              ]),
              totalJasaDiskon: countDiscount([...resultService, ...prevJob]),
              totalJasaSesudahDiskon: countAfterDiscount([
                ...resultService,
                ...prevJob,
              ]),
            },
          },
        };
      });
    }
  };

  fetchPromo = async () => {
    const { onTriggerLoading, setError, formData } = this.props;
    const { dataTransaksi, dataUnit, kodeCabang } = formData;
    const mergedPart = [
      ...(dataTransaksi?.dataPartNonQR || []),
      ...(dataTransaksi?.dataPartQR || []),
    ];

    if (dataTransaksi?.dataJob?.length === 0 && mergedPart.length === 0) {
      return;
    }
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPromoFjb,
      menuName: "Faktur Jual Bengkel",
      setError,
      args: {
        kodeCabang: kodeCabang?.value,
        kodeVariant: dataUnit?.kodeVarian?.value,
        serviceDate: moment().format("DD-MM-YYYY"),
        listService: dataTransaksi?.dataJob?.map((item) => ({
          serviceCode: item.kodeJasa?.value,
        })),
        parts: mergedPart?.map((item) => ({ kodePart: item.kodePart?.value })),
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        promoOptions: res.data.data.map((item) => {
          return {
            label: item.promoName,
            value: item.promoId,
            id: item.id,
            ...item,
          };
        }),
      });
    }
  };

  onSetLocalState = (callback) => {
    this.setState(callback);
  };

  handleApplyPromo = async (value) => {
    const { onTriggerLoading, setError, onSetState } = this.props;
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPromoDetailFjb,
      menuName: "Faktur Jual Bengkel",
      setError,
      args: {
        id: value?.id,
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const prm = res.data.data;

      if (prm) {
        calculateAndSetPromo({
          onSetState: onSetState,
          promo: prm || [],
          setLocalState: this.onSetLocalState,
        });
      }
    }
  };

  restoreData = (current, backupList, type) => {
    const key = type === "part" ? "kodePart" : "kodeJasa";
    return current.map(
      (item) =>
        backupList?.find((b) => b[key]?.value === item[key]?.value) || item
    );
  };

  handleDeselectPromo = () => {
    const { backupPromo } = this.state;
    const { formData, onSetState } = this.props;
    const trx = formData?.dataTransaksi;

    this.setValue("namaPromo", null);

    this.props.handlePelanggaran(false, "APPRV0042");

    const part = this.restoreData(
      trx.dataPartNonQR,
      backupPromo.tableNonQr,
      "part"
    );
    const partQR = this.restoreData(
      trx.dataPartQR,
      backupPromo.tableQr,
      "part"
    );
    const job = this.restoreData(trx.dataJob, backupPromo.tableJasa);
    const combined = [...part, ...partQR];

    onSetState((prev) => {
      return {
        ...prev,
        data: {
          ...prev.data,
          dataTransaksi: {
            ...prev.data.dataTransaksi,
            dataPartNonQR: part,
            dataPartQR: partQR,
            dataJob: job,
            totalJasaSebelumDiskon: countBeforeDiscount(job),
            totalJasaDiskon: countDiscount(job),
            totalJasaSesudahDiskon: countAfterDiscount(job),
            totalPartSebelumDiskon: countBeforeDiscount(combined, "part"),
            totalPartDiskon: countDiscount(combined),
            totalPartSesudahDiskon: countAfterDiscount(combined),
          },
        },
      };
    });
  };

  handleSelectPromo = () => {
    const { formData, onTriggerAlert } = this.props;
    const { dataTransaksi } = formData;
    const { dataJob, dataPartNonQR, dataPartQR } = dataTransaksi;
    const merged = [
      ...(dataJob || []),
      ...(dataPartNonQR || []),
      ...(dataPartQR || []),
    ];
    if (merged.some((item) => !item.isSaved)) {
      return onTriggerAlert(
        "Informasi",
        "Terdapat data yang belum disimpan. Harap Periksa Kembali"
      );
    }
    if (dataTransaksi.tipePromo && dataTransaksi?.tipePromo === "PROMO") {
      this.setValue("tipePromo", null);
      return this.handleDeselectPromo();
    }
    this.setValue("tipePromo", "PROMO");
  };

  handleCheckQtyPart = async (payload) => {
    const { onTriggerLoading, onSetState, setError, formData } = this.props;
    const { dataTransaksi } = formData;
    const merged = [
      ...(dataTransaksi?.dataPartQR || []),
      ...(dataTransaksi?.dataPartNonQR || []),
    ];
    const isValidDataTable =
      merged?.length > 0 &&
      merged?.every((item) => item.kodePart?.value && item.isSaved);
    if (!isValidDataTable) {
      return;
    }
    onTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getStockAndPartsByLocatorFjb,
      menuName: "Faktur Jual Bengkel",
      setError: setError,
      args: {
        kodeLocator: payload?.value,
        partCodes: dataTransaksi.dataPartNonQR?.map(
          (item) => item.kodePart?.value
        ),
        partQRCodes: dataTransaksi.dataPartQR?.map(
          (item) => item.kodePart?.value
        ),
      },
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const { part = [], partQR = [] } = res.data.data;

      onSetState((prev) => {
        const prevQr = [...(prev?.data?.dataTransaksi?.dataPartQR || [])];
        const prevNonQr = [...(prev?.data?.dataTransaksi?.dataPartNonQR || [])];

        const resultNonQR = prevNonQr?.map((item) => {
          const found = part.find((p) => p.partCode === item.kodePart?.value);
          return {
            ...item,
            qtyStock: found ? found?.stockQty || 0 : item.qtyStock, 
          };
        });

        const resultQR = prevQr?.map((item) => {
          const found = partQR.find((p) => p.partCode === item.kodePart?.value);
          return {
            ...item,
            qtyStock: found ? found?.stockQty || 0 : item.qtyStock, 
          };
        });

       
        return {
          ...prev,
          data: {
            ...prev.data,
            dataTransaksi: {
              ...prev.data.dataTransaksi,
              dataPartQR: resultQR,
              dataPartNonQR: resultNonQR,
            },
          },
        };
      });
    }
  };

  getQtyPartQR = async (data) => {
    const { setError, formData } = this.props;
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getPartFJB,
      menuName: "Faktur Jual Bengkel",
      setError: setError,
      args: {
        kodeCabang: formData?.kodeCabang?.value,
        kodeVariant: formData?.dataUnit?.kodeVarian?.value,
        serviceDate: moment().format("DD-MM-YYYY"),
        kodePart: data?.kodeItem,
        partName: "%",
        qrCode: true,
        kodeLokator: formData?.dataTransaksi?.locator?.value,
      },
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      return res.data.data[0];
    }
    return null;
  };

  handleScanQR = async (data) => {
    const { onTriggerLoading, setError, formData, onSetState, onTriggerAlert } =
      this.props;
    const { dataTransaksi } = formData;
    onTriggerLoading();
    const response = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").findBarcodePartMutation,
      menuName: "Faktur Jual Bengkel",
      setError: setError,
      args: {
        nameCategory: "PART",
        encryptBarcode: data[0]?.rawValue,
        kodeCabang: formData.kodeCabang?.value,
        kodeLocator: dataTransaksi?.locator?.value,
        trxType: "TRX_IN",
      },
    });
    onTriggerLoading();

    if (response?.ok && response?.data?.status === HttpStatus?.SUCCESS) {
      if (!response.data.data) {
        onTriggerAlert(
          "Informasi",
          "QR Code tidak terdapat pada lokasi gudang sparepart. Mohon periksa kembali."
        );
        this.handleScannerVisibility();
        return;
      }
      const idxUnsaved = dataTransaksi?.dataPartQR?.findIndex(
        (item) => !item.isSaved
      );
      const tableData =
        idxUnsaved !== undefined && idxUnsaved !== -1
          ? dataTransaksi?.dataPartQR[idxUnsaved]
          : null;
      if (
        tableData &&
        tableData?.kodePart?.value === response?.data?.data?.kodeItem
      ) {
        onSetState((prev) => {
          const data = [...prev.data.dataTransaksi.dataPartQR];
          data[idxUnsaved] = {
            ...data[idxUnsaved],
            qrCode: response?.data?.data?.barcode,
          };

          return {
            ...prev,
            data: {
              ...prev.data,
              dataTransaksi: {
                ...prev.data.dataTransaksi,
                dataPartQR: data,
              },
            },
          };
        });
      } else {
        const dataQr = await this.getQtyPartQR(response.data.data);
        onSetState((prev) => {
          const prevQr = [...(prev?.data?.dataTransaksi?.dataPartQR || [])];
          return {
            ...prev,
            data: {
              ...prev.data,
              dataTransaksi: {
                ...prev.data.dataTransaksi,
                dataPartQR: [
                  ...prevQr,
                  {
                    ...INITIAL_DATA_TABLE_PART_QR,
                    qrCode: response?.data?.data?.barcode,
                    kodePart: mapToObjectDDL(
                      dataQr?.kodePart,
                      dataQr?.kodePart
                    ),
                    namaPart: mapToObjectDDL(
                      dataQr?.partName,
                      dataQr?.kodePart
                    ),
                    qtyStock: dataQr?.stockQty,
                    hargaSatuanSistem: dataQr?.price,
                    hargaDiberikan: dataQr?.price,
                    totalHarga: dataQr?.price,
                    qtyPart: 1,
                  },
                ],
              },
            },
          };
        });
      }
    }
    this.handleScannerVisibility();
  };

  render() {
    const {
      packageOptions,
      locatorOptions,
      bankOptions,
      promoOptions,
      scannerVisible,
    } = this.state;

    const { formData, activityType, listIdPelanggaran } = this.props;
    const dataTransaksi = formData?.dataTransaksi;

    const isReadOnly = activityType === ACTIVITY_TYPE.VIEW;
    return (
      <React.Fragment>
        <SimpleDDL
          id="select_options_lokasi_gudang_sparepart"
          name="locator"
          box="search"
          label="Lokasi Gudang SparePart"
          isClearable
          readOnly={isReadOnly}
          value={dataTransaksi.locator}
          options={locatorOptions}
          containerclassname="width width-350px"
          onChange={(value, { name }) => {
            this.setValue(name, value);
            if (value?.value) {
              this.loadPart(value?.value);
              this.handleCheckQtyPart(value);
            }
          }}
        />
        <SimpleDDL
          id="select_options_nama_paket"
          name="paket"
          box="search"
          label="Nama Paket"
          isClearable
          readOnly={isReadOnly}
          value={dataTransaksi.paket}
          options={packageOptions}
          containerclassname="width width-350px"
          showErrorWithoutMandatory
          errorMessage={
            listIdPelanggaran?.includes("APPRV0043")
              ? "Paket memasuki masa grace periode - butuh approval"
              : null
          }
          onChange={(value, { name }) => {
            this.setValue(name, value);
            this.getDetailPackage(value);
            this.props.handlePelanggaran(value?.inGracePeriode, "APPRV0043");
          }}
        />

        <FlexView column style={{ gap: "15px", marginBottom: "20px" }}>
          <h4 className="txt-site txt-16 txt-main txt-bold">
            JOB / Jasa Bengkel
          </h4>
          <SimpleButton
            styles={{ marginLeft: "0px" }}
            text="Tambah"
            disabled={isReadOnly}
            secondary={isReadOnly}
            onClick={() => this.handleAddTableData("dataJob")}
            icon={<i className="fa fa-plus margin-right-10px" />}
          />
          <SimpleDataTable
            data={dataTransaksi.dataJob || []}
            columns={this.getTableConfig()}
            options={{ pagination: false }}
          />
        </FlexView>

        <FlexView style={{ gap: "50px" }} hAlignContent="right">
          <span>
            Total Estimasi Waktu : {dataTransaksi.totalEstimasiWaktu} Menit
          </span>
          <FlexView column style={{ gap: "5px", minWidth: "250px" }}>
            <SummaryRow
              label="Total Sebelum Diskon"
              value={FormatCurrencyWithoutSymbol({
                number: dataTransaksi.totalJasaSebelumDiskon,
              })}
            />
            <SummaryRow
              label="Diskon"
              value={FormatCurrencyWithoutSymbol({
                number: dataTransaksi.totalJasaDiskon,
              })}
            />
            <SummaryRow
              label="Total Sesudah Diskon"
              value={FormatCurrencyWithoutSymbol({
                number: dataTransaksi.totalJasaSesudahDiskon,
              })}
            />
          </FlexView>
        </FlexView>

        <FlexView column style={{ gap: "15px", marginBottom: "20px" }}>
          <h4 className="txt-site txt-16 txt-main txt-bold">Part Dengan QR</h4>
          <FlexView style={{ gap: "20px" }}>
            <SimpleButton
              styles={{ marginLeft: "0px" }}
              text="Tambah"
              disabled={isReadOnly}
              secondary={isReadOnly}
              onClick={() => {
                this.handleAddTableData("dataPartQR");
              }}
              icon={<i className="fa fa-plus margin-right-10px" />}
            />
            <SimpleButton
              category="action_button"
              disabled={isReadOnly}
              secondary={isReadOnly}
              onClick={this.handleScannerVisibility}
              icon={<i className="fa fa-qrcode"></i>}
            />
          </FlexView>
          <SimpleDataTable
            data={dataTransaksi.dataPartQR || []}
            columns={this.getTableConfigWithQR()}
            options={{ pagination: false }}
          />
        </FlexView>
        <FlexView column style={{ gap: "15px", marginBottom: "20px" }}>
          <h4 className="txt-site txt-16 txt-main txt-bold">Part Tanpa QR</h4>
          <SimpleButton
            styles={{ marginLeft: "0px" }}
            text="Tambah"
            secondary={isReadOnly}
            disabled={isReadOnly}
            onClick={() => {
              this.handleAddTableData("dataPartNonQR");
            }}
            icon={<i className="fa fa-plus margin-right-10px" />}
          />
          <SimpleDataTable
            data={dataTransaksi.dataPartNonQR || []}
            columns={this.getTableConfigWithoutQR()}
            options={{ pagination: false }}
          />
        </FlexView>

        <FlexView style={{ justifyContent: "space-between" }}>
          <div style={{ fontSize: "16px" }}>
            <FlexView vAlignContent="center" style={{ gap: "20px" }}>
              <SimpleRadio
                option="Promo"
                disabled={isReadOnly}
                active={dataTransaksi.tipePromo === "PROMO"}
                onChange={() => this.handleSelectPromo()}
              />
              <SimpleRadio
                option="Voucher"
                disabled={isReadOnly}
                active={dataTransaksi.tipePromo === "VOUCHER"}
                onChange={() => {
                  if (dataTransaksi.tipePromo === "VOUCHER") {
                    this.setValue("tipePromo", null);
                    return;
                  }
                  this.setValue("tipePromo", "VOUCHER");
                  this.setValue("namaPromo", null);
                  this.setValue("promoId", null);
                  this.handleDeselectPromo();
                }}
              />
            </FlexView>
            {dataTransaksi.tipePromo === "PROMO" && (
              <SimpleDDL
                id="select_options_nama_promo"
                name="namaPromo"
                box="search"
                label="Nama Promo"
                readOnly={isReadOnly}
                containerclassname="width width-350px"
                value={dataTransaksi.namaPromo}
                showErrorWithoutMandatory
                onMenuOpen={() => {
                  this.fetchPromo();
                }}
                errorMessage={
                  listIdPelanggaran?.includes("APPRV0042")
                    ? "Promo memasuki masa grace periode - butuh approval"
                    : null
                }
                options={promoOptions}
                onChange={(value, { name }) => {
                  this.props.handlePelanggaran(
                    value?.inGracePeriode,
                    "APPRV0042"
                  );
                  this.props.handlePelanggaran(false, "APPRV0040");
                  this.setValue("namaPromo", value);
                  this.setValue("promoId", value?.value);
                  this.handleApplyPromo(value);
                }}
              />
            )}
            {dataTransaksi.tipePromo === "VOUCHER" && (
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleInput
                  id="id_input_kode_voucher"
                  containerclassname="width width-full"
                  value={null}
                  readOnly={isReadOnly}
                  label={"Kode Voucher"}
                />
                <SimpleButton
                  text="Submit Voucher"
                  disabled={isReadOnly}
                  secondary={isReadOnly}
                  containerclassname="margin margin-top-5px"
                />
              </FlexView>
            )}

            <div className="txt-site txt-16 txt-main txt-bold">
              <h4>PERMBAYARAN</h4>
            </div>
            <FlexView vAlignContent="center" style={{ gap: "20px" }}>
              <SimpleRadio
                option="Tunai"
                disabled={isReadOnly}
                active={dataTransaksi?.tipePembayaran === "TUNAI"}
                onChange={() => {
                  this.setValue("tipePembayaran", "TUNAI");
                  this.setValue("kodeBank", null);
                  this.setValue("tipePembayaranNonTunai", null);
                }}
              />
              <SimpleRadio
                option="Non Tunai"
                disabled={isReadOnly}
                active={dataTransaksi?.tipePembayaran === "NON_TUNAI"}
                onChange={() => this.setValue("tipePembayaran", "NON_TUNAI")}
              />
              {dataTransaksi?.tipePembayaran === "NON_TUNAI" && (
                <SimpleDDL
                  id="select_options_nama_promo"
                  name="tipePembayaranNonTunai"
                  box="search"
                  isClearable
                  isReadOnly={isReadOnly}
                  containerclassname="width width-250px"
                  value={dataTransaksi?.tipePembayaranNonTunai}
                  options={TIPE_PEMBAYARAN_NON_TUNAI_OPTIONS}
                  onChange={(value, { name }) => {
                    this.setValue(name, value);
                    if (value?.value === "QRIS") {
                      this.setValue("kodeBank", null);
                    }
                  }}
                />
              )}
            </FlexView>
            {dataTransaksi?.tipePembayaranNonTunai?.value === "TRANSFER" && (
              <SimpleDDL
                id="select_options_kode_bank"
                name="kodeBank"
                box="search"
                label="Kode Bank"
                isClearable
                readOnly={isReadOnly}
                containerclassname="width width-full"
                value={dataTransaksi?.kodeBank}
                options={bankOptions}
                onChange={(value, { name }) => this.setValue(name, value)}
              />
            )}
          </div>

          <FlexView column style={{ gap: "5px" }}>
            <SummaryRow
              label="Total Sebelum Diskon"
              value={FormatCurrencyWithoutSymbol({
                number: dataTransaksi.totalPartSebelumDiskon,
              })}
            />
            <SummaryRow
              label="Diskon"
              value={FormatCurrencyWithoutSymbol({
                number: dataTransaksi.totalPartDiskon,
              })}
            />
            <SummaryRow
              label="Total Sesudah Diskon"
              value={FormatCurrencyWithoutSymbol({
                number: dataTransaksi.totalPartSesudahDiskon,
              })}
            />
            <Line />
            <SummaryRow
              label="Titipan Hotline"
              value={FormatCurrencyWithoutSymbol({
                number: dataTransaksi.totalTitipanHotlin,
              })}
            />
            <SummaryRow
              label="Kelebihan / Kekurangan"
              value={FormatCurrencyWithoutSymbol({
                number: dataTransaksi.totalKelebihanKekurangan,
              })}
            />
          </FlexView>
        </FlexView>
        {scannerVisible && (
          <SimpleModal
            title={"Scan QR Here"}
            styles={{ width: "40%" }}
            visible={scannerVisible}
            onClickClose={this.handleScannerVisibility}
            content={
              <Scanner
                onScan={this.handleScanQR}
                constraints={{
                  height: { ideal: 720 },
                  video: {
                    facingMode: { exact: "environment" },
                    height: { ideal: 720 },
                  },
                }}
              />
            }
          />
        )}
      </React.Fragment>
    );
  }
}

export default TabDataTransaksiFJB;
